import React, { useEffect } from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { useNavigate } from 'react-router-dom';
import ParentLayout from '../Layout';
import Navigation from '@/dialogs_common/Navigation';
import Urls from '../Urls';
import Activities from './Activities';
import { PayloadStates } from '@lore/utils';
import useRouter from '@/hooks/useRouter';
import useTags from '@/hooks/useTags';
import TagTypes from '@/constants/TagTypes';

export default function Layout() {
  const { history, match } = useRouter();
  const navigate = useNavigate();

  const user = useUser();

  const projectId = Number(match.params.projectId);
  const safeProjectId = isNaN(projectId) ? -1 : projectId;
  const project = useConnect('project.byId', {
    id: safeProjectId
  });

  const activities = useTags(TagTypes.Activity);

  const shouldRedirect = isNaN(projectId) ||
    project.state === PayloadStates.NOT_FOUND ||
    project.state === PayloadStates.ERROR_FETCHING ||
    project.state === PayloadStates.DELETED;

  useEffect(() => {
    if (shouldRedirect) {
      navigate('/my-leading', { replace: true });
    }
  }, [shouldRedirect]);

  if (shouldRedirect ||
    project.state === PayloadStates.INITIAL_STATE ||
    project.state === PayloadStates.FETCHING ||
    activities.state === PayloadStates.FETCHING
  ) {
    return null;
  }

  return (
    <ParentLayout
      project={project}
      page="Activity"
      title={(
        <>
          Which form of <a className="text-white underline hover:text-cs-orange-500" href="https://drive.google.com/file/d/1XcGLTbR8WA8dETan3DeGfUUHYXZxkRcl/view" target="_blank" rel="noreferrer">Community-Engaged Learning</a> would best support your project?
        </>
      )}
      description={(
        <div className="space-y-4">
          <div>
            <span className="font-semibold italic">TIP</span>: If you have an involved project and
            are looking for several different partners to engage in a variety of different ways
            with you or your students, a &#34;Challenge&#34; is a good place to start.
          </div>
          <div className="font-semibold">
            Choose ONE Activity Type.
          </div>
        </div>
      )}
    >
      <Activities
        user={user}
        project={project}
        activities={activities}
        navigation={(
          <Navigation v5={true} activeStep={0} steps={19}/>
        )}
        onPrevious={() => history.push(Urls(project).SCHOOL)}
        onNext={() => history.push(Urls(project).TITLE)}
        onSkip={() => history.push(Urls(project).TITLE)}
      />
    </ParentLayout>
  );
};
